import { Tag } from 'lucide-react';

interface Props {
    tags?: string[];
    highlightTags?: string[];
}

const PlayTagDisplay: FC<Props> = ({ tags = [], highlightTags = [] }) => {
    if (tags.length === 0) {
        return null;
    }

    return (
        <div className="play-tag-display small text-muted">
            <Tag className="tag-icon" />
            {tags
                .reduce((acc, tag) => {
                    return [...acc, highlightTags.includes(tag) ? <em key={Math.random()}>{tag}</em> : tag, ', '];
                }, [])
                .slice(0, -1)}
        </div>
    );
};

export default PlayTagDisplay;
